var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", {
      domProps: {
        innerHTML: _vm._s(
          _vm.$t("notification.whatsappBroadcastCompleted", {
            title: _vm.$_.get(_vm.activity, "payload.title"),
            numbers: _vm.$_.get(_vm.activity, "payload.numbers"),
          })
        ),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }